import moment from 'moment';

import * as actionTypes from 'actions/OrderWaitingApproveManagementActions';
import { roundTimeQuarterHour } from 'utils/format';

const initFilter = {
  startDate: moment(roundTimeQuarterHour())
    .subtract(2, 'days')
    .toDate(),
  endDate: moment(roundTimeQuarterHour())
    .add(3, 'days')
    .toDate(),
  status: 'toan_bo'
};
const initialState = {
  listOrder: [],
  filter: initFilter,
  loading: false,
  color: '',
  selectedOrder: []
};

const orderWaitingApproveManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_FILTER_DATA: {
      return {
        ...state,
        filter: {
          ...state.filter,
          ...action.data
        }
      };
    }

    case actionTypes.SET_ORDERS: {
      return {
        ...state,
        listOrder: action.listOrder,
        loading: false,
        selectedOrder: []
      };
    }

    case actionTypes.SET_COLOR: {
      return {
        ...state,
        color: action.color
      };
    }

    case actionTypes.SET_LOADING: {
      return {
        ...state,
        loading: action.loading
      };
    }

    case actionTypes.SET_SELECTED_ORDER: {
      return {
        ...state,
        selectedOrder: action.selected
      };
    }

    default: {
      return state;
    }
  }
};

export default orderWaitingApproveManagementReducer;
